import request from '@/utils/request'

// 超管概览页
// 批次数
export const getBatchNum = () => {
  return request({
    url: '/trace/index/batch/num'
  })
}

// 机构总数
export const getGovNum = () => {
  return request({
    url: '/trace/index/gov/num'
  })
}

// 当年销售情况排名
export const getMerchantReport = () => {
  return request({
    url: '/trace/index/merchant/report'
  })
}

// 订单报表
export const getOrderReport = () => {
  return request({
    url: '/trace/index/order/report'
  })
}

// 企业总数
export const getOrgNum = () => {
  return request({
    url: '/trace/index/org/num'
  })
}

// 产品 总数、在产数、停产
export const getProductNum = () => {
  return request({
    url: '/trace/index/product/num'
  })
}

// 溯源码 总数、已打印、未打印
export const getQrcodeNum = () => {
  return request({
    url: '/trace/index/qrcode/num'
  })
}

// 人员总数
export const getUserNum = () => {
  return request({
    url: '/trace/index/user/num'
  })
}
